module.exports = __webpack_public_path__ + "img/document-big.a98a66f0.svg";